export default __webpack_public_path__ + "static/media/logo-mobile.4ea2bf3b.png";